import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getAuthenticatedAxios } from "./use-authenticated-axios"
import type { DeleteAccessTokenParams } from "src/internal-types"

export const useDeleteAccessToken = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (params: DeleteAccessTokenParams) => {
      const axios = getAuthenticatedAxios()
      const { data } = await axios.post(
        "/internal/access_tokens/delete",
        params
      )
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["access_tokens"] })
    },
  })
}
